import React, { useState, useEffect } from "react";
import { TextField } from "@material-ui/core";
import { useInput } from "react-admin";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import moment from "moment";

export default function RaDateInput(props) {
    const {source, defaultValue = true, initialValue = ""} = props;
	const { input: { onChange } } = useInput(props);
    const { input: { value: sourceValue } } = useInput({ ...props, id: source, source: source });
    const [selectedDate, setSelectedDate] = useState(null);

    useEffect(() => {
        if (props.expiryDate) {
            const formatted = moment().utcOffset("+05:30").add(1, 'months').subtract(1, "day").toDate()
            onChange(formatted)
            setSelectedDate(formatted)
        }
        else if (sourceValue && sourceValue !== "" && sourceValue !== "null") {
            onChange(sourceValue)
            setSelectedDate(sourceValue)
        }
        else if (defaultValue){
            onChange(new Date())
            setSelectedDate(new Date())
        }
        else {
            onChange(null)
            setSelectedDate(null)
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (initialValue && initialValue !== "" && initialValue !== "null") {
            onChange(initialValue)
            setSelectedDate(initialValue)
        }
        
    }, [initialValue]); // eslint-disable-line react-hooks/exhaustive-deps

	return (<MuiPickersUtilsProvider utils={DateFnsUtils}>
        <DatePicker
            value={selectedDate}
            onChange={(date) => {
                onChange(date)
                setSelectedDate(date)
            }}
            inputVariant="outlined"
            format="dd/MM/yyyy"
            size="small"
            renderInput={(params) => <TextField {...params} />}
            {...props}
        />
	</MuiPickersUtilsProvider>);
};